import { CorrelationParams, createEntityActions, createTypedAction, EntityActionType, newAggregationId } from '@aston/foundation';
import { createAction, props } from '@ngrx/store';
import { IFederationForm, IFederationListItem } from 'apps/console/src/app/federations-module/models';

const ActionPrefix = 'Federations';

export const federationsListActions = {
	...createEntityActions<{ subsidiaries:IFederationListItem[], hasPendingItems:boolean }>(ActionPrefix, 'List'),

	LoadFederationsRequest: createTypedAction(
		EntityActionType.LoadEntityRequest,
		`[${ActionPrefix}] Load List Request`,
		(correlationParams: CorrelationParams = { correlationId: newAggregationId() }) => ( { correlationParams } )
	),
	LoadFederationsSuccess: createTypedAction(
		EntityActionType.LoadEntitySuccess,
		`[${ActionPrefix}] Load List Success`,
		props<{ entity: IFederationListItem[], hasPendingItems: boolean, correlationParams?: CorrelationParams }>()
	),
	LoadFederationsFailure: createTypedAction(
		EntityActionType.LoadEntityFailure,
		`[${ActionPrefix}] Load List Failure`,
		props<{ error: Error }>()
	),
};

export const {
	LoadFederationsRequest,
	LoadFederationsSuccess,
	LoadFederationsFailure
} = federationsListActions;

export const federationsEntityActions = {
	...createEntityActions<IFederationForm>(ActionPrefix, 'Federation Entity'),
};

export const NewFederation = createAction(`[${ActionPrefix}] New Federation`);

export const {
	LoadEntityByIdRequest: LoadFederationRequest,
	LoadEntitySuccess: LoadFederationSuccess,
	LoadEntityFailure: LoadFederationFailure,
	CreateEntityRequest: CreateFederationRequest,
	CreateEntitySuccess: CreateFederationSuccess,
	CreateEntityFailure: CreateFederationFailure,
	UpdateEntityRequest: UpdateFederationRequest,
	UpdateEntitySuccess: UpdateFederationSuccess,
	UpdateEntityFailure: UpdateFederationFailure,
	DeleteEntityConfirm: DeleteFederationConfirm,
	DeleteEntityByIdRequest: DeleteFederationRequest,
	DeleteEntitySuccess: DeleteFederationSuccess,
	DeleteEntityFailure: DeleteFederationFailure
} = federationsEntityActions;

export const RedirectTo = createAction(`[${ActionPrefix}] Redirect To Federation`, props<{ federationId: number, path?: string }>());
export const RedirectToNewTab = createAction(`[${ActionPrefix}] Redirect To Federation new Tab`, props<{ federationId: number }>());
